import { useState, useEffect } from 'react';
import { useGET } from 'hooks/useRequest';

import {
  branchTermSingular,
  branchTermSingularCapitalised,
} from 'utils/terminology';
import ProductPricing from 'components/products/product_pricing';
import CEFMessage from 'components/cef_message/cef_message';
import ThreePLMessage from 'components/threePLMessage';
import StoreAddressBox from './store_address_box';
import warningIcon from '../../../assets/images/shared/icons/info.svg';

/**
 * @param {Object} props
 * @param {boolean} props.catalogue - Current product catalogue code
 * @param {boolean} props.productId - Current product ID
 * @param {function} props.vatStatus - Vat status of site
 * @param {boolean} props.currentProductName - Full description of current product
 * @param {function} props.currentStore - The Current store information if available
 * @param {function} props.collectionLocationSet - Bool to show if user has a store set
 * @param {function} props.selectAStoreUrl - URL for change store page
 * @returns Renewables product right hand column for product detail page
 */

const RenewablesProductShowColumn = ({
  catalogue,
  productId,
  vatStatus,
  currentProductName,
  currentStore,
  collectionLocationSet,
  selectAStoreUrl,
  fetchPrice,
  segenProduct,
}) => {
  const [productPrice, setProductPrice] = useState();

  /**
   * TODO remove the fetchPrice prop and call to pricing service
   * once we move over to the new product page
   */
  const { data: priceResponse, loading } = useGET(
    fetchPrice ? `/product_price?products=${productId}` : null,
  );

  useEffect(() => {
    if (priceResponse) {
      setProductPrice(priceResponse[productId]);
    }
  }, [priceResponse]);

  if (fetchPrice && !productPrice) {
    return null;
  }

  return (
    <div className="mb-30 m-mb-0 renewables-info-container">
      {fetchPrice && (
        <ProductPricing
          v1
          id={productId}
          isLoading={loading}
          prices={productPrice}
          vatStatus={vatStatus}
        />
      )}

      <CEFMessage
        icon={warningIcon}
        title={`Order via your local ${branchTermSingular}`}
        classNames="fl-col">
        <ThreePLMessage threePLType={segenProduct ? 'Segen' : 'Other'} />
      </CEFMessage>

      {!collectionLocationSet ? (
        <a
          href={selectAStoreUrl}
          className="cef-btn cef-btn--green cef-btn--full-width fs-18">
          Find a {branchTermSingularCapitalised}
        </a>
      ) : (
        <StoreAddressBox
          catalogue={catalogue}
          icon={warningIcon}
          currentProductName={currentProductName}
          selectAStoreUrl={selectAStoreUrl}
          currentStore={currentStore}
          showTelephoneLink
          showEmailLink
          showStoreIcon
        />
      )}
    </div>
  );
};

export default RenewablesProductShowColumn;
